import React, { useState } from "react";
import citybanner from "../assets/cityad.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const City = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "cityLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Honda City",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={citybanner} alt="Honda City" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      <section className="about-gravite">
        <h2>Experience the New Honda City</h2>

        <p>
          The Honda City continues to be one of India's most premium and
          dependable sedans, offering elegant styling, refined performance, and
          advanced hybrid technology. Available with Honda's acclaimed e:HEV
          strong hybrid system, the City delivers excellent fuel efficiency,
          premium comfort, connected features, and Honda Sensing ADAS safety
          technologies. With its spacious cabin and smooth driving experience,
          the Honda City remains a benchmark in the midsize sedan segment.
        </p>
      </section>

      <section className="tech-data">
        <h2>Technical Specifications of the Honda City</h2>

        <table>
          <thead>
            <tr>
              <th>Specification</th>
              <th colSpan="4">Honda City</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Starting Price</td>
              <td colSpan="4">₹12.38 Lakh (Ex-Showroom)</td>
            </tr>

            <tr>
              <td>Hybrid Price</td>
              <td colSpan="4">₹20.85 Lakh (Ex-Showroom)</td>
            </tr>

            <tr>
              <td>Engine</td>
              <td colSpan="4">1.5L i-VTEC Petrol / 1.5L e:HEV Hybrid</td>
            </tr>

            <tr>
              <td>Power</td>
              <td colSpan="4">121 PS (Petrol) / 126 PS (Hybrid)</td>
            </tr>

            <tr>
              <td>Torque</td>
              <td colSpan="4">145 Nm (Petrol) / 253 Nm (Hybrid)</td>
            </tr>

            <tr>
              <td>Transmission</td>
              <td colSpan="4">6-Speed Manual / CVT / e-CVT</td>
            </tr>

            <tr>
              <td>Fuel Efficiency</td>
              <td colSpan="4">Up to 27.26 km/l (Hybrid)</td>
            </tr>

            <tr>
              <td>Infotainment</td>
              <td colSpan="4">8-inch Touchscreen with Wireless Android Auto & Apple CarPlay</td>
            </tr>

            <tr>
              <td>Instrument Cluster</td>
              <td colSpan="4">7-inch TFT Digital Display</td>
            </tr>

            <tr>
              <td>Safety</td>
              <td colSpan="4">
                Honda Sensing ADAS, 6 Airbags, Lane Watch Camera, Vehicle Stability Assist
              </td>
            </tr>

            <tr>
              <td>Boot Space</td>
              <td colSpan="4">506 Litres</td>
            </tr>
          </tbody>
        </table>
      </section>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default City;